/**
 * Jquery setup.
 */
$(function() {
    let token = $("meta[name='csrf-token']").attr("content");
    $.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': token
        }
    });
});